import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Telefono2FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TELÉFONO 2' htmlFor='input-telefono2' md={2} />
      <Col md={10}>
        <Field name='telefono2'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-telefono2'
              placeholder='Ingresar telefono ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Telefono2FormGroup)
